import { createFileRoute } from "@tanstack/react-router";
import { FAQ } from "@/components/landing/faq";
import { Footer } from "@/components/landing/footer";
import { Nav } from "@/components/landing/nav";

export const Route = createFileRoute("/faq")({
	component: FAQPage,
	head: () => ({
		meta: [
			{ title: "FAQ — Proxi | Frequently Asked Questions" },
			{
				name: "description",
				content:
					"Answers about Proxi's escrow, wallet top-ups, cancellations, Proxi Private, Proxi Premium, and referrals. Everything you need to know before posting an errand in Lagos.",
			},
			{ property: "og:title", content: "FAQ — Proxi" },
			{
				property: "og:description",
				content:
					"Common questions about using Proxi for errands in Lagos, Nigeria.",
			},
			{ property: "og:url", content: "https://myproxi.ng/faq" },
			{
				name: "twitter:title",
				content: "FAQ — Proxi",
			},
			{
				name: "twitter:description",
				content:
					"Common questions about using Proxi for errands in Lagos, Nigeria.",
			},
		],
		links: [{ rel: "canonical", href: "https://myproxi.ng/faq" }],
	}),
});

function FAQPage() {
	return (
		<div className="overflow-x-hidden">
			<Nav />
			<main className="pt-24">
				<FAQ />
			</main>
			<Footer />
		</div>
	);
}
